import { isAfter, isSameWeek, parseISO } from "date-fns";
import { locale } from "src/lib/locale/date-fns";
import type { PosterProps } from "src/components/posterrow/Poster";
import { isFilmwebIdGraphQLUserContent } from "src/lib/filmwebid/useMovieIdentifier";
import type { Movie } from "src/lib/movieinfo/movieinfotypes";
import { isMovie } from "src/lib/movieinfo/typeGuards";
import { isFilmomtale } from "src/lib/types/Filmomtale";
;

const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

export function isPremiereThisWeek(movie: Movie): boolean {
    if (movie?.premiere && movie?.isPremiereConfirmed) {
        const prem = parseISO(movie.premiere);
        return isSameWeek(prem, new Date(), { locale, weekStartsOn: 1 });
    }

    return false;
}

/**
  * @param movie
 * @returns
 */
export function isTooFarAhead(movie: Movie, cutoff: Date): boolean {
    if (BRAND === "filmweb") {
        return false;
    }

    if (movie?.premiere && movie?.isPremiereConfirmed) {
        const prem = parseISO(movie.premiere);
        return isAfter(prem, cutoff);
    }
    return false;
}

/**
 * Whether a poster should show the Kinoklubb banner: the film (or a user list item's film) is a Kinoklubb film
 * and the banner isn't hidden.
 */
export function showKinoklubbBanner(film: PosterProps["film"] | undefined, hideKinoklubbBanner = false): boolean {
    if (!film || hideKinoklubbBanner) {
        return false;
    }
    const content = isFilmwebIdGraphQLUserContent(film) ? film.watchableContent : film;
    if (isMovie(content)) {
        return content.isKinoklubb;
    }
    if (isFilmomtale(content)) {
        return !!content.isKinoklubb;
    }
    return false;
}